(function () {
  'use strict';

  function initRail(section) {
    if (section.dataset.bestsellerInitialized === 'true') return;

    var track = section.querySelector('[data-bestseller-track]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-bestseller-card]')) : [];
    var progress = section.querySelector('[data-bestseller-progress]');
    var current = section.querySelector('[data-bestseller-current]');

    if (!track || !progress || !current || cards.length === 0) return;

    section.dataset.bestsellerInitialized = 'true';
    section.style.setProperty('--bestseller-count', cards.length);

    var ticking = false;
    var feedbackTimers = new WeakMap();

    function update() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var scrollProgress = maxScroll ? Math.min(1, Math.max(0, track.scrollLeft / maxScroll)) : 0;
      var segmentWidth = 100 / cards.length;
      var travel = 100 - segmentWidth;
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      progress.style.transform = 'translateX(' + (scrollProgress * travel * cards.length) + '%)';
      current.textContent = String(nearestIndex + 1);
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });
    section.addEventListener('cart:update', function (event) {
      var data = event.detail && event.detail.data;
      if (!data || data.source !== 'product-form-component' || data.didError) return;

      var productForm = Array.prototype.find.call(
        section.querySelectorAll('product-form-component[data-product-id]'),
        function (form) {
          return String(form.dataset.productId) === String(data.productId);
        }
      );
      if (!productForm) return;

      var button = productForm.querySelector('.bestseller-card__button');
      var liveRegion = productForm.querySelector('[data-bestseller-live-region]');
      var card = productForm.closest('[data-bestseller-card]');
      var title = card && card.querySelector('.bestseller-card__title');
      if (!button) return;

      button.classList.add('is-added-feedback');
      if (liveRegion) {
        liveRegion.textContent = '';
        window.requestAnimationFrame(function () {
          liveRegion.textContent = (title ? title.textContent.trim() : 'Produkt') + ' wurde hinzugefügt';
        });
      }

      if (feedbackTimers.has(button)) window.clearTimeout(feedbackTimers.get(button));
      feedbackTimers.set(button, window.setTimeout(function () {
        button.classList.remove('is-added-feedback');
        if (liveRegion) liveRegion.textContent = '';
        feedbackTimers.delete(button);
      }, 1800));
    });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-bestseller-rail]')) initRail(root);
    root.querySelectorAll('[data-bestseller-rail]').forEach(initRail);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
